import { createActionName } from "../../../utility"

export const reducerName = "pages"

export const PAGE = createActionName(reducerName, "PAGE")
export const PAGES = createActionName(reducerName, "PAGES")
